import { render, staticRenderFns } from "./attence.vue?vue&type=template&id=04e960c4&"
import script from "./attence.vue?vue&type=script&lang=ts&"
export * from "./attence.vue?vue&type=script&lang=ts&"
import style0 from "./attence.vue?vue&type=style&index=0&id=04e960c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports